import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterTiltShiftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_tilt_shift"}/>
}
